import { PathVariables } from './types';

export function getPathVariableNames<TPath extends string>(
  path: TPath,
): Array<keyof PathVariables<TPath>> {
  const matches = Array.from(path.matchAll(/:(\w+)\b/g));
  const variableNames = matches.map(([_, name]) => name);

  return variableNames as Array<keyof PathVariables<TPath>>;
}
